import React from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import AccountDetailsForm from '../components/AccountDetailsForm';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from '../../common/Button';
import { toast } from 'react-toastify';
import { updateAccountDetail } from '../../../api/accountDetailApi';

export interface EditAccountDetailsProps {
  done: (account?: any) => void;
  cancel: () => void;
  account: any;
}

const EditAccountDetails = ({
  done,
  cancel,
  account,
}: EditAccountDetailsProps) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const onSubmit = (data: any) => {
    updateAccountDetail(account.id, { ...account, ...data })
      .then(() => {
        toast.success(t('Account details saved'));
        done({ ...account, ...data });
      })
      .catch((e) => {
        console.error(e);
        toast.error(t('Failed to save account details'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Edit account details')}
      cancel={cancel}
      bar={
        <Button
          type="submit"
          text={t('Save')}
          onClick={handleSubmit(onSubmit)}
          className="btn btn-primary"
          testId="save-account-details-button"
        />
      }
    >
      {account && (
        <AccountDetailsForm
          account={account}
          register={register}
          errors={errors}
          control={control}
        />
      )}
    </SlideoutLayout>
  );
};

export default EditAccountDetails;
